/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    INVOICES_RECEIVE,
    INVOICES_REQUEST,
    INVOICES_REQUEST_SUCCESS,
    INVOICES_REQUEST_FAILURE
} from 'state/action-types';

export const items = createReducer([], {
    [INVOICES_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [INVOICES_REQUEST]: () => true,
    [INVOICES_REQUEST_SUCCESS]: () => false,
    [INVOICES_REQUEST_FAILURE]: () => false,
});

export const error = createReducer(false, {
    [INVOICES_REQUEST]: () => false,
    [INVOICES_REQUEST_SUCCESS]: () => false,
    [INVOICES_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
